import { useTranslation } from "react-i18next";

import styles from "./styles";

import { WhiteSpace } from "../";

const Card = ({ item }) => {
  return (
    <div style={styles.card}>
      <p>{item.opinion}</p>

      <WhiteSpace height="15px" />

      <b>{item.first}</b>

      <p>{item.second}</p>

      <WhiteSpace height="10px" />

      <b>{item.third}</b>
    </div>
  );
};

const SpecialCard = ({ item }) => {
  return (
    <div style={styles.specialCard}>
      <p>{item.opinion}</p>

      <WhiteSpace height="15px" />

      <b>{item.first}</b>

      <p>{item.second}</p>

      <WhiteSpace height="30px" />

      <div style={styles.whiteShade}></div>
    </div>
  );
};

const OpinionsGrid = () => {
  const { t: translation } = useTranslation("home");

  const data = [
    {
      opinion: translation("opinionsGrid.opinion1"), // Translation key
      first: translation("opinionsGrid.james"), // Translation key
      second: translation("opinionsGrid.coFounder"), // Translation key
      third: translation("opinionsGrid.flash"), // Translation key
    },
    {
      opinion: translation("opinionsGrid.opinion1"),
      first: translation("opinionsGrid.james"),
      second: translation("opinionsGrid.coFounder"),
      third: translation("opinionsGrid.flash"),
    },
    {
      opinion: translation("opinionsGrid.opinion1"),
      first: translation("opinionsGrid.james"),
      second: translation("opinionsGrid.coFounder"),
      third: translation("opinionsGrid.flash"),
    },
    {
      opinion: translation("opinionsGrid.opinion1"),
      first: translation("opinionsGrid.james"),
      second: translation("opinionsGrid.coFounder"),
      third: translation("opinionsGrid.flash"),
    },
    {
      opinion: translation("opinionsGrid.opinion1"),
      first: translation("opinionsGrid.james"),
      second: translation("opinionsGrid.coFounder"),
      third: translation("opinionsGrid.flash"),
    },
    {
      opinion: translation("opinionsGrid.opinion1"),
      first: translation("opinionsGrid.james"),
      second: translation("opinionsGrid.coFounder"),
      third: translation("opinionsGrid.flash"),
    },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.column}>
        <Card item={data[0]} />
        <Card item={data[1]} />
      </div>
      <div style={styles.specialColumn}>
        <Card item={data[2]} />
        <SpecialCard item={data[3]} />
      </div>
      <div style={styles.column}>
        <Card item={data[4]} />
        <Card item={data[5]} />
      </div>
    </div>
  );
};

export default OpinionsGrid;
